import type { FooterLink } from '../../../../../types';

import seekAnzLinks from './seekAnz';
import seekBusinessLinks from './seekBusiness';
import talentLinks from './talent';

export const getLinks = (site: string): FooterLink[] => {
  switch (site) {
    case 'seekBusiness':
      return seekBusinessLinks;
    case 'talent':
      return talentLinks;
    default:
      return seekAnzLinks;
  }
};
